import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

// Shared layout + typography for HiBFF legal pages. Policy wording is
// founder-supplied and VERBATIM — formatting only, never edit the words.

export const H2 = ({ id, children }) => (
  <h2 id={id} className="text-lg sm:text-xl font-extrabold text-gray-900 mt-10 mb-3">{children}</h2>
);
export const H3 = ({ children }) => (
  <h3 className="text-base font-bold text-gray-900 mt-6 mb-2">{children}</h3>
);
export const P = ({ children }) => <p className="text-[15px] leading-7 text-gray-700 mb-3">{children}</p>;
export const UL = ({ items }) => (
  <ul className="list-disc pl-6 space-y-1.5 text-[15px] leading-7 text-gray-700 mb-3">
    {items.map((it, i) => <li key={i}>{it}</li>)}
  </ul>
);
export const OL = ({ items }) => (
  <ol className="list-decimal pl-6 space-y-1.5 text-[15px] leading-7 text-gray-700 mb-3">
    {items.map((it, i) => <li key={i}>{it}</li>)}
  </ol>
);

export default function LegalLayout({ title, subtitle, lastUpdated, testId, children }) {
  return (
    <div className="min-h-screen bg-gray-50" data-testid={testId}>
      <div className="max-w-3xl mx-auto px-4 py-8 sm:py-12">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-800 mb-6" data-testid={`${testId}-back-home`}>
          <ArrowLeft size={14} /> Back to HiBFF
        </Link>
        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-6 sm:p-10">
          <h1 className="text-2xl sm:text-3xl font-extrabold text-gray-900 tracking-tight">{title}</h1>
          {subtitle ? <p className="text-sm font-semibold text-gray-600 mt-2">{subtitle}</p> : null}
          <p className="text-xs text-gray-500 mt-1 mb-2" data-testid={`${testId}-last-updated`}>Last Updated: {lastUpdated}</p>
          {children}
        </div>
        <p className="text-[11px] text-gray-400 mt-4 text-center">HIBFF LTD · Registered in England and Wales · Company number 16232868</p>
      </div>
    </div>
  );
}
